import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { ActionItemGroup } from "@/lib/Components/Actions/ActionGroupButtons";
import { ActionMenu } from "@/lib/Components/Menu/ActionMenu";
import { FC } from "react";

interface IconMenuProps {
  actionGroups: ActionItemGroup[];
  Icon?: FC<any>;
}

export function IconMenu({
  actionGroups,
  Icon = EllipsisVerticalIcon,
}: IconMenuProps) {
  return (
    <ActionMenu
      button={
        <div className="flex rounded-md p-2 hover:bg-gray-100/50">
          <Icon className="h-5 w-5" />
        </div>
      }
      actionGroups={actionGroups}
    />
  );
}
